import { CalendarGridRow_default } from "../Calendar/CalendarGridRow.js";
import { createBlock, defineComponent, guardReactiveProps, normalizeProps, openBlock, renderSlot, unref, withCtx } from "vue";

//#region src/DatePicker/DatePickerGridRow.vue?vue&type=script&setup=true&lang.ts
var DatePickerGridRow_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
	__name: "DatePickerGridRow",
	props: {
		asChild: {
			type: Boolean,
			required: false
		},
		as: {
			type: null,
			required: false
		}
	},
	setup(__props) {
		const props = __props;
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(CalendarGridRow_default), normalizeProps(guardReactiveProps(props)), {
				default: withCtx(() => [renderSlot(_ctx.$slots, "default")]),
				_: 3
			}, 16);
		};
	}
});

//#endregion
//#region src/DatePicker/DatePickerGridRow.vue
var DatePickerGridRow_default = DatePickerGridRow_vue_vue_type_script_setup_true_lang_default;

//#endregion
export { DatePickerGridRow_default };
//# sourceMappingURL=DatePickerGridRow.js.map